import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import packageJson from '../../../../package.json';

export const Home = props => {
  const history = useHistory();
  const handleClick = () => history.push('/');

  useEffect(() => {
    
  },[]);

    return (
      <React.Fragment>
        <div className="container">
        <br></br>
            <div className="text-center">            
                <p className="badge badge-primary text-center" >
                    <strong>Surf 1.3 Web App {packageJson.version}</strong><br></br>
                </p>
            </div>
                <div className="text-center">
                A web IoT application designed and developed by S.& A.S.Co.Ltd has developed a leading name for itself in the field of industrial electronic controls through the continuous introduction of new products that are of extremely high quality and completely reliable. Extra attention is paid to the look, ease of manipulation, and installation of the product. You will find that our products agree with your budget and yet are still of the utmost quality and innovation. Our product range includes control relays, diesel generating sets controllers, elevator controllers, emergency landing devices, and VVVF drives for elevators.<br></br>
                        S. & A.S. Co. Ltd is based in Jieh, a beautiful seaside village located 24km south of Beirut. The Jieh location is a 1000sqm building that serves as our headquarters offices and production facility. S. & A.S. also has an office in Beirut that supports the local distribution of our products.<br></br>
                        Starting January 11th, 2021 the quality management system of the company is certified by AB certification to be in compliance with ISO 9001:2015 in the scope of design, manufacture, and sales of electronic controllers.<br></br>
                        <p className="badge badge-primary text-wrap" >
                           <strong>S. & A.S. Co. Ltd  PROUDLY MADE IN LEBANON.</strong><br></br>
                        </p>
                </div>
                <center>
                    <a className="btn btn-secondary" href="https://www.sascontrollers.com/generators/automatic-mains-failure-surfamf-auto-start-enhanced-surfautov1.3a" role="button">View Device Info</a>
                </center>
            </div>
      </React.Fragment>
    );
};
